import React from 'react';
import Hero from '../components/home/Hero';
import Services from '../components/home/Services';
import Stylists from '../components/home/Stylists';
import Gallery from '../components/home/Gallery';

export default function Home() {
  return (
    <main>
      <Hero />
      <Services />
      <Stylists />
      <Gallery />
    </main>
  );
}